/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetEquipmentBrowserViewRequest = {
  /**
   * The id of the equipment browser view. If not specified, the default view will be returned.
   */
  viewId?: string | undefined;
  agentId: string;
};

/** @internal */
export type GetEquipmentBrowserViewRequest$Outbound = {
  view_id?: string | undefined;
  agent_id: string;
};

/** @internal */
export const GetEquipmentBrowserViewRequest$outboundSchema: z.ZodType<
  GetEquipmentBrowserViewRequest$Outbound,
  z.ZodTypeDef,
  GetEquipmentBrowserViewRequest
> = z.object({
  viewId: z.string().optional(),
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    viewId: "view_id",
    agentId: "agent_id",
  });
});

export function getEquipmentBrowserViewRequestToJSON(
  getEquipmentBrowserViewRequest: GetEquipmentBrowserViewRequest,
): string {
  return JSON.stringify(
    GetEquipmentBrowserViewRequest$outboundSchema.parse(
      getEquipmentBrowserViewRequest,
    ),
  );
}
